import { render, staticRenderFns } from "./HelperTaxasPgtOnline.vue?vue&type=template&id=595e6058&lang=pug"
import script from "./HelperTaxasPgtOnline.vue?vue&type=script&lang=js"
export * from "./HelperTaxasPgtOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports